import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'
import fetchAPI from '../../common/fetchAPI';
import { sortData } from '../../common/timeLiveFunction';
import { BillingRateStateClass } from './interfaces/billingRateStateClass';

const initialState: BillingRateStateClass = {
    isLoading: false,
    isReload: false,
    status: 'idle',
    accountBillingRateId: 0,
    accountProjectRoleId: 0,
    accountProjectEmployeeId: 0,
    accountProjectTaskId: 0,
    accountWorkTypeId: 0,
    shortName: '',
    employeeName: '',
    profilePictureColor: '',
    billingRateList: [],
    projectBillingRateType: [],
    accountWorkType: [],
    accountEmployeeId: 0,
    sortOrder: 'asc',
    sortColumn: 'BillingRate'
}
interface IThunkApi {
    state: {
        billingRate: BillingRateStateClass;
    }
}
export const getAccountBillingRatesByAccountEmployeeId = createAsyncThunk
    <any, void, IThunkApi>
    (
        'billingRate/getAccountBillingRatesByAccountEmployeeId',
        async (arg, thunkApi) => {
            const { accountEmployeeId, accountWorkTypeId } = thunkApi.getState().billingRate;
            const response = await fetchAPI(`api/V2/BillingRates/GetAccountBillingRatesByAccountEmployeeId/${accountEmployeeId}/${accountWorkTypeId}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    )
export const getAccountBillingRateList = createAsyncThunk
    <any, void, IThunkApi>
    (
        'billingRate/getAccountBillingRateList',
        async (arg, thunkApi) => {
            const { accountProjectRoleId, accountWorkTypeId } = thunkApi.getState().billingRate;
            const response = await fetchAPI(`api/V2/BillingRates/GetAccountBillingRatesByAccountProjectRoleId/${accountProjectRoleId}/${accountWorkTypeId}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    )

export const getAccountBillingRateByAccountProjectEmployeeId = createAsyncThunk
    <any, any, IThunkApi>
    (
        'billingRate/getAccountBillingRateByAccountProjectEmployeeId',
        async (arg, thunkApi) => {
            const { accountProjectEmployeeId, accountWorkTypeId } = thunkApi.getState().billingRate;
            const response = await fetchAPI(`api/V2/BillingRates/GetAccountBillingRatesByAccountProjectEmployeeId/${accountProjectEmployeeId}/${accountWorkTypeId}/${arg}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    )

export const getAccountBillingRateByAccountProjectTaskId = createAsyncThunk
    <any, void, IThunkApi>
    (
        'billingRate/getAccountBillingRateByAccountProjectTaskId',
        async (arg, thunkApi) => {
            const { accountProjectTaskId, accountWorkTypeId } = thunkApi.getState().billingRate;
            const response = await fetchAPI(`api/V2/BillingRates/GetAccountBillingRatesByAccountProjectTaskId/${accountProjectTaskId}/${accountWorkTypeId}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    )

export const addAccountBillingRate = createAsyncThunk
    <any, any, IThunkApi>
    (
        'billingRate/addAccountBillingRate',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/BillingRates/AddAccountBillingRate', 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const updateAccountBillingRate = createAsyncThunk
    <any, any, IThunkApi>
    (
        'billingRate/updateAccountBillingRate',
        async (arg, thunkApi) => {
            const { accountBillingRateId } = thunkApi.getState().billingRate;
            const response = await fetchAPI(`api/V2/BillingRates/UpdateAccountBillingRate/${accountBillingRateId}`, 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountBillingRate = createAsyncThunk
    <any, any, IThunkApi>
    (
        'billingRate/deleteAccountBillingRate',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/BillingRates/DeleteAccountBillingRate/' + arg, 'DELETE', '', true);
            const json = await response.json();
            return json;
        }
    )

export const billingRateSlice = createSlice({
    name: 'billingRate',
    initialState,
    reducers: {
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateAccountBillingRateId: (state, action: PayloadAction<any>) => {
            state.accountBillingRateId = action.payload;
        },
        updateAccountProjectRoleId: (state, action: PayloadAction<any>) => {
            state.accountProjectRoleId = action.payload.AccountProjectRoleId;
            state.accountWorkTypeId = action.payload.AccountWorkTypeId;
        },
        updateAccountProjectEmployeeId: (state, action: PayloadAction<any>) => {
            state.accountProjectEmployeeId = action.payload.AccountProjectEmployeeId;
            state.accountWorkTypeId = action.payload.AccountWorkTypeId;
        },
        updateAccountWorkTypeId: (state, action: PayloadAction<any>) => {
            state.accountWorkTypeId = action.payload;
        },
        updateAccountProjectTaskId: (state, action: PayloadAction<any>) => {
            state.accountProjectTaskId = action.payload.AccountProjectTaskId;
            state.accountWorkTypeId = action.payload.AccountWorkTypeId;
        },
        updateAccountEmployeeId: (state, action: PayloadAction<any>) => {
            state.accountEmployeeId = action.payload.AccountEmployeeId;
            state.accountWorkTypeId = action.payload.AccountWorkTypeId;
        },
        updateAccountEmployeeIdFromSummary: (state, action: PayloadAction<any>) => {
            state.accountEmployeeId = action.payload;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            let tempArray = state.billingRateList;
            state.billingRateList = sortData(tempArray, state.sortOrder, state.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountBillingRatesByAccountEmployeeId.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountBillingRatesByAccountEmployeeId.fulfilled, (state, action) => {
                //state.billingRateList = action.payload["AccountBillingRate"];
                state.billingRateList = sortData(action.payload["AccountBillingRate"], state.sortOrder, state.sortColumn);
                state.projectBillingRateType = action.payload["ProjectBillingRateType"];
                let tempArray = action.payload["AccountWorkType"]
                tempArray.map((item: any) => {
                    item.value = item.AccountWorkTypeId;
                    item.label = item.AccountWorkType;
                    delete item.AccountWorkTypeId;
                    delete item.AccountWorkType;
                });
                state.accountWorkType = tempArray;
                let tempEmployeeArray = action.payload["AccountEmployee"][0];
                state.employeeName = `${tempEmployeeArray.FirstName} ${tempEmployeeArray.LastName}`;
                state.shortName = `${tempEmployeeArray.FirstName.split('')[0].toUpperCase()}${tempEmployeeArray.LastName.split('')[0].toUpperCase()}`;
                state.profilePictureColor = tempEmployeeArray.ProfilePictureColor;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getAccountBillingRatesByAccountEmployeeId.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getAccountBillingRateList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountBillingRateList.fulfilled, (state, action) => {
                // state.billingRateList = action.payload["AccountBillingRate"];
                state.billingRateList = sortData(action.payload["AccountBillingRate"], state.sortOrder, state.sortColumn);
                state.projectBillingRateType = action.payload["ProjectBillingRateType"];
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getAccountBillingRateList.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getAccountBillingRateByAccountProjectEmployeeId.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountBillingRateByAccountProjectEmployeeId.fulfilled, (state, action) => {
                //state.billingRateList = action.payload["AccountBillingRate"];
                state.billingRateList = sortData(action.payload["AccountBillingRate"], state.sortOrder, state.sortColumn);
                state.projectBillingRateType = action.payload["ProjectBillingRateType"];
                let tempArray = action.payload["AccountWorkType"]
                tempArray.map((item: any) => {
                    item.value = item.AccountWorkTypeId;
                    item.label = item.AccountWorkType;
                    delete item.AccountWorkTypeId;
                    delete item.AccountWorkType;
                });
                state.accountWorkType = tempArray;
                let tempEmployeeArray = action.payload["AccountEmployee"][0];
                state.employeeName = `${tempEmployeeArray.FirstName} ${tempEmployeeArray.LastName}`;
                state.shortName = `${tempEmployeeArray.FirstName.split('')[0].toUpperCase()}${tempEmployeeArray.LastName.split('')[0].toUpperCase()}`;
                state.profilePictureColor = tempEmployeeArray.ProfilePictureColor;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getAccountBillingRateByAccountProjectEmployeeId.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getAccountBillingRateByAccountProjectTaskId.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountBillingRateByAccountProjectTaskId.fulfilled, (state, action) => {
                //state.billingRateList = action.payload["AccountBillingRate"];
                state.billingRateList = sortData(action.payload["AccountBillingRate"], state.sortOrder, state.sortColumn);
                state.projectBillingRateType = action.payload["ProjectBillingRateType"];
                let tempArray = action.payload["AccountWorkType"]
                tempArray.map((item: any) => {
                    item.value = item.AccountWorkTypeId;
                    item.label = item.AccountWorkType;
                    delete item.AccountWorkTypeId;
                    delete item.AccountWorkType;
                });
                state.accountWorkType = tempArray;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getAccountBillingRateByAccountProjectTaskId.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addAccountBillingRate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountBillingRate.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;;
                state.isLoading = false;
            })
            .addCase(addAccountBillingRate.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(updateAccountBillingRate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountBillingRate.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;;
                state.isLoading = false;
            })
            .addCase(updateAccountBillingRate.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAccountBillingRate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountBillingRate.fulfilled, (state, action) => {
                state.billingRateList = state.billingRateList.filter(x => x.AccountBillingRateId != Number(action.payload.Id));
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(deleteAccountBillingRate.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})

export const {
    updateIsLoading,
    updateAccountBillingRateId,
    updateAccountProjectRoleId,
    updateAccountProjectEmployeeId,
    updateAccountWorkTypeId,
    updateAccountProjectTaskId,
    updateAccountEmployeeId,
    updateAccountEmployeeIdFromSummary,
    updateSorting
} = billingRateSlice.actions
export const BillingRateState = (state: RootState) => state.billingRate
export default billingRateSlice.reducer